import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useMaintenanceMode = () => {
  return useQuery({
    queryKey: ["maintenance-mode"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("site_settings")
        .select("value")
        .eq("key", "maintenance_mode")
        .maybeSingle();

      if (error) {
        console.error("Error fetching maintenance mode:", error);
        return false;
      }

      // Type guard for JSON value
      if (!data?.value || typeof data.value !== 'object' || Array.isArray(data.value)) {
        return false;
      }
      
      return (data.value as { enabled?: boolean }).enabled === true;
    },
    staleTime: 1000 * 60, // 1 minute
    refetchInterval: 1000 * 60, // Refetch every minute
  });
};
